import { InvestorGoalDatesRepository } from '../../../domain/repositories/investor-goal-dates-repository';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class InvestorGoalDatesDummyRepository implements InvestorGoalDatesRepository {
  update(): Promise<any> {
    return Promise.resolve();
  }
}
